module.exports = __webpack_public_path__ + "static/img/全局透视.dabc7f6d.png";